{
  "zh-TW": {
    "messages": {
      "copy": {
        "success": "文本已複製！",
        "failure": "無法複製文本"
      },
      "copyGitRevision": {
        "success": "Git 版本已複製！",
        "failure": "無法複製 Git 版本"
      },
      "copyImageUrl": {
        "success": "圖片鏈接已複製！",
        "failure": "無法複製圖片鏈接"
      },
      "copyVideoUrl": {
        "success": "視頻鏈接已複製！",
        "failure": "無法複製視頻鏈接"
      },
      "copyShareUrl": {
        "success": "鏈接 \"%{url}\" 已複製！",
        "failure": "無法複製鏈接"
      },
      "copyInviteUrl": {
        "success": "邀請鏈接 \"%{url}\" 已複製！",
        "failure": "無法複製邀請鏈接"
      },
      "copyTwoFactorProvisioningUrl": {
        "success": "配置網址已複製！",
        "failure": "無法複製配置網址"
      },
      "copyBackupCodes": {
        "success": "備份代碼已複製！",
        "failure": "無法複製備份代碼"
      },
      "signup": {
        "success": "<b>歡迎來到FleetYards.net！</b> 您的帳戶已建立。<br>您將收到一封確認郵件以啟用您的帳戶。",
        "invalid": "請解決錯誤後再建立帳戶。",
        "failure": "我們無法建立您的帳戶。請稍後再試。"
      },
      "accountConfirm": {
        "success": "您的帳戶已成功確認。<br>您現在可以登入。",
        "failure": "您的帳戶無法確認。"
      },
      "requestPasswordChange": {
        "success": "如果您的電子郵件地址存在於我們的資料庫中，您將在幾分鐘內收到密碼重置連結。"
      },
      "changePassword": {
        "success": "您的密碼已成功更改。",
        "failure": "您的密碼無法更新。"
      },
      "updateProfile": {
        "success": "個人資料已更新。",
        "failure": "個人資料無法更新。"
      },
      "updateHangar": {
        "success": "機庫設定已更新。"
      },
      "updatePrivacy": {
        "success": "隱私設定已更新。"
      },
      "features": {
        "updated": "功能已更新。",
        "error": "無法更新功能。",
        "actorAdded": "角色已新增到功能。",
        "actorRemoved": "角色已從功能中移除。",
        "groupAdded": "群組已新增到功能。",
        "groupRemoved": "群組已從功能中移除。",
        "created": "功能已建立。",
        "destroyed": "功能已移除。"
      },
      "rsiRequestLogs": {
        "resolved": "請求日誌已標記為已解決。",
        "error": "無法更新請求日誌。"
      },
      "updateNotifications": {
        "success": "通知設定已更新。",
        "failure": "無法儲存您的通知設定。"
      },
      "updateAccount": {
        "success": "帳戶已更新。"
      },
      "oauthApplications": {
        "create": {
          "success": "OAuth 應用程式已建立。",
          "error": "無法建立 OAuth 應用程式。"
        },
        "update": {
          "success": "OAuth 應用程式已更新。",
          "error": "無法更新 OAuth 應用程式。"
        },
        "destroy": {
          "success": "OAuth 應用程式已刪除。",
          "error": "無法刪除 OAuth 應用程式。"
        },
        "regenerateSecret": {
          "success": "客戶端密鑰已重新產生。",
          "error": "無法重新產生客戶端密鑰。"
        },
        "copied": "已複製到剪貼簿。",
        "copyError": "無法複製到剪貼簿。",
        "secretWarning": "請立即複製客戶端密鑰。您將無法再次檢視。"
      },
      "avatarUpload": {
        "create": {
          "success": "頭像已上傳",
          "failure": "無法上傳頭像"
        },
        "destroy": {
          "success": "頭像已移除",
          "failure": "無法移除頭像"
        }
      },
      "hangarImport": {
        "success": "匯入完成",
        "partialSuccess": "匯入部分完成。<br><br>未找到的飛船：<br>%{missing}",
        "failure": "匯入失敗"
      },
      "hangarExport": {
        "failure": "匯出失敗，請稍後再試。"
      },
      "vehicle": {
        "add": {
          "success": {
            "noHtml": "您的新%{model}將送達您的機庫",
            "paragraph1": "您的新",
            "paragraph2": "將送達您的"
          }
        },
        "addToWishlist": {
          "success": {
            "noHtml": "您的新%{model}已新增至您的願望清單",
            "paragraph2": "已新增至您的"
          }
        },
        "resetIngame": {
          "moveToWishlist": {
            "success": "已將所有遊戲內購買的飛船移至您的願望清單。",
            "failure": "無法將所有遊戲內購買的飛船移至您的願望清單。"
          },
          "removeAll": {
            "success": "已從您的機庫移除所有遊戲內購買的飛船。",
            "failure": "無法從您的機庫移除所有遊戲內購買的飛船。"
          }
        }
      },
      "model": {
        "onSale": "%{model}現在特價中！",
        "syncMatrixStarted": "Model matrix sync started. You will be notified when it completes.",
        "syncScDataStarted": "Model SC data sync started. You will be notified when it completes.",
        "importPaintsStarted": "塗裝匯入已開始。完成後會通知您。"
      },
      "fundingGoal": {
        "created": "募資目標已建立。",
        "updated": "募資目標已更新。",
        "destroyed": "募資目標已刪除。",
        "createFailed": "無法建立募資目標。",
        "updateFailed": "無法更新募資目標。"
      },
      "supporterContribution": {
        "created": "支持者捐助已建立。",
        "updated": "支持者捐助已更新。",
        "destroyed": "支持者捐助已刪除。",
        "createFailed": "無法建立支持者捐助。",
        "updateFailed": "無法更新支持者捐助。"
      },
      "notification": {
        "granted": "歡迎使用FleetYards.net通知！"
      },
      "twoFactor": {
        "enable": {
          "success": "雙因素驗證已啟用！",
          "failure": "無法啟用雙因素驗證。"
        },
        "disable": {
          "success": "雙因素驗證已停用！",
          "failure": "無法停用雙因素驗證。"
        },
        "backupCodes": {
          "failure": "無法生成備份代碼。"
        }
      },
      "error": {
        "usernameTaken": "使用者名稱已被使用。",
        "userNotFound": "找不到使用者",
        "emailTaken": "電子郵件已被使用。",
        "fleetTaken": "艦隊名稱已被使用。",
        "colorInvalid": "顏色無效",
        "serialTaken": "序號已被使用。",
        "textInvalid": "%{field}無效",
        "hangar": {
          "accountRequired": {
            "noHtml": "您需要註冊或登入以新增飛船至您的機庫。",
            "paragraph1": "您需要",
            "paragraph2": "以新增飛船至您的機庫。",
            "paragraph3": "取得更多資訊"
          }
        },
        "default": "<b>發生了錯誤。</b><br>您試過重新啟動嗎？"
      },
      "account": {
        "destroy": {
          "success": "<b>您的帳戶已刪除。</b><br>很遺憾看到您離開 :'(",
          "failure": "我們無法刪除您的帳戶！請稍後再試。"
        },
        "calendarSubscription": {
          "enable": {
            "success": "個人行事曆訂閱已啟用。",
            "failure": "無法啟用行事曆訂閱。"
          },
          "rotate": {
            "success": "個人行事曆連結已更換。現有訂閱者在重新訂閱前將不會再收到更新。",
            "failure": "無法更換個人行事曆連結。",
            "confirm": "更換連結會讓訂閱目前網址的行事曆應用程式在沒有任何提示的情況下失效。您需要用新連結重新訂閱。"
          },
          "disable": {
            "success": "個人行事曆訂閱已停用。",
            "failure": "無法停用個人行事曆訂閱。",
            "confirm": "停用訂閱會中斷目前所有已訂閱的行事曆應用程式的資料來源。"
          }
        }
      },
      "user": {
        "destroy": {
          "success": "使用者已刪除。",
          "failure": "無法刪除使用者。"
        }
      },
      "fleet": {
        "create": {
          "success": "您的艦隊已建立。",
          "failure": "艦隊無法儲存。"
        },
        "update": {
          "success": "設定已儲存。",
          "failure": "設定無法儲存。"
        },
        "destroy": {
          "success": "您的艦隊已刪除。",
          "failure": "我們無法刪除您的艦隊。"
        },
        "leave": {
          "success": "您已離開艦隊。",
          "failure": "無法離開艦隊。"
        },
        "invites": {
          "accept": {
            "success": "邀請已接受。",
            "failure": "無法接受邀請。"
          },
          "decline": {
            "success": "邀請已拒絕。",
            "failure": "無法拒絕邀請。"
          },
          "create": {
            "failure": "無法邀請使用者。"
          }
        },
        "members": {
          "update": {
            "success": "設定已儲存。",
            "failure": "設定無法儲存。"
          },
          "destroy": {
            "success": "成員已移除。",
            "failure": "成員無法移除。"
          },
          "demote": {
            "success": "成員已降級。",
            "failure": "成員無法降級。"
          },
          "promote": {
            "success": "成員已升級。",
            "failure": "成員無法升級。"
          },
          "accept": {
            "success": "成員已接受。",
            "failure": "成員無法接受。"
          },
          "decline": {
            "success": "成員已拒絕。",
            "failure": "成員無法拒絕。"
          }
        },
        "calendarSubscription": {
          "enable": {
            "success": "行事曆訂閱已啟用。",
            "failure": "無法啟用行事曆訂閱。"
          },
          "rotate": {
            "success": "訂閱連結已更換。現有訂閱者在重新訂閱前將不會再收到更新。",
            "failure": "無法更換訂閱連結。",
            "confirm": "更換連結會讓訂閱目前網址的行事曆應用程式在沒有任何提示的情況下失效。他們需要用新連結重新訂閱。"
          },
          "disable": {
            "success": "行事曆訂閱已停用。",
            "failure": "無法停用行事曆訂閱。",
            "confirm": "停用訂閱會中斷目前所有已訂閱的行事曆應用程式的資料來源。"
          },
          "copy": {
            "success": "行事曆連結已複製。請將它貼到您的行事曆應用程式的\"訂閱行事曆\"或\"以網址新增\"中。",
            "failure": "無法複製行事曆連結。"
          }
        }
      },
      "fleetInvite": {
        "used": "<b>已發送加入%{fleet}的申請！</b><br>一旦您的會員資格被接受，您將收到電子郵件通知",
        "failure": "邀請無法使用。",
        "notFound": "找不到邀請。",
        "confirm": "您確定要加入艦隊：\"%{fleet}\"嗎？"
      },
      "holoViewer": {
        "modelLoader": {
          "failure": "我們無法載入請求的3D模型！請稍後再試。"
        },
        "webglNotSupported": "此裝置無法使用 3D 檢視器。"
      },
      "cargoGridViewer": {
        "confirmReset": "Are you sure you want to reset all ships and container settings?"
      },
      "confirm": {
        "vehicle": {
          "destroy": "您確定要從機庫移除此飛船嗎？"
        },
        "hangarGroup": {
          "destroy": "您確定要從機庫移除此群組嗎？"
        },
        "hangar": {
          "import": "匯入的飛船將新增至您的機庫，不會與現有飛船匹配。<br><br>支援的格式為：Fleetyards匯出、Starship42或HangarXplor。<br><br>您要繼續嗎？",
          "destroySelected": "您確定要從機庫移除所有選中的飛船嗎？此操作無法復原。",
          "destroyAll": "您確定要從機庫移除所有飛船嗎？此操作無法復原。"
        },
        "wishlist": {
          "destroyAll": "您確定要從願望清單移除所有飛船嗎？此操作無法復原。"
        },
        "account": {
          "destroy": "您確定要刪除您的帳戶嗎？此操作無法復原。",
          "destroyWithFleets": "您是以下艦隊的管理員：%{fleets}。刪除帳戶也會一併解散這些艦隊並移除其所有成員。此操作無法復原。要繼續嗎？"
        },
        "itemPrice": {
          "destroy": "Are you sure you want to destroy this Item Price? This Action can't be reverted."
        },
        "fleet": {
          "leave": "您確定要離開艦隊嗎？此操作無法復原。",
          "destroy": "您確定要刪除您的艦隊嗎？此操作無法復原。",
          "members": {
            "destroy": "您確定要移除此成員嗎？",
            "remove": "確定要將該成員從艦隊中移除嗎？"
          },
          "invites": {
            "decline": "您確定要拒絕此邀請嗎？此操作無法復原。"
          }
        },
        "oauthApplication": {
          "destroy": "確定要刪除此 OAuth 應用程式嗎? 此操作無法撤銷。",
          "regenerateSecret": "確定要重新產生客戶端密鑰嗎? 現有整合將停止運作。"
        },
        "twoFactor": {
          "generateBackupCodes": "您確定要重新生成雙因素備份代碼嗎？"
        },
        "user": {
          "loginAs": "Are you sure you want to login as this user?",
          "resendConfirmation": "Are you sure you want to resend the confirmation email for this user?",
          "sendPasswordReset": "Are you sure you want to send a password reset email for this user?",
          "destroy": "Are you sure you want to delete this user? This action can't be reverted.",
          "destroyWithFleets": "此使用者是以下艦隊的管理員：%{fleets}。刪除該使用者也會一併解散這些艦隊並移除其所有成員。此操作無法復原。要繼續嗎？"
        },
        "model": {
          "destroy": "Are you sure you want to delete this model? This action can't be reverted.",
          "sync": "Are you sure you want to sync this model from RSI?",
          "syncMatrix": "Are you sure you want to sync the ship matrix data for this model?",
          "syncScData": "Are you sure you want to sync the SC data for this model?",
          "importPaints": "確定要從機庫資料匯入此型號的塗裝嗎？來源若將某個塗裝標示為整個系列共用，該系列的每個型號都會匯入這個塗裝。",
          "exchangeStoreImage": "Are you sure you want to replace the store image with the RSI image?",
          "reloadMatrix": "Are you sure you want to reload the models matrix? This will enqueue background jobs.",
          "reloadScData": "Are you sure you want to reload SC data? This will enqueue background jobs.",
          "reloadPaints": "確定要重新載入塗裝嗎？這會排入背景工作。",
          "reloadModules": "確定要重新載入模組嗎？這會排入背景工作。",
          "reloadLoaners": "確定要重新載入借用船嗎？這會排入背景工作。"
        },
        "manufacturer": {
          "destroy": "Are you sure you want to delete this manufacturer? This action can't be reverted."
        },
        "fundingGoal": {
          "destroy": "確定要刪除此募資目標嗎？此操作無法復原。"
        },
        "supporterContribution": {
          "destroy": "確定要刪除此支持者捐助嗎？此操作無法復原。"
        },
        "modelPosition": {
          "destroy": "確定要刪除此職位嗎？此操作無法復原。"
        },
        "modelLoaner": {
          "destroy": "確定要刪除此借用船嗎? 此操作無法撤銷。"
        },
        "modelSnubCraft": {
          "destroy": "確定要刪除此 Snub Craft 嗎？此操作無法復原。"
        },
        "modelPaint": {
          "destroy": "Are you sure you want to delete this paint? This action can't be reverted."
        },
        "video": {
          "destroy": "Are you sure you want to delete this video? This action can't be reverted."
        },
        "modelModule": {
          "destroy": "Are you sure you want to delete this module? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this module from the model? The module will still exist but won't be associated with this model."
        },
        "modelUpgrade": {
          "destroy": "Are you sure you want to delete this upgrade? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this upgrade from the model? The upgrade will still exist but won't be associated with this model."
        },
        "modelModulePackage": {
          "destroy": "Are you sure you want to delete this module package? This action can't be reverted."
        },
        "dock": {
          "destroy": "Are you sure you want to delete this dock? This action can't be reverted."
        },
        "component": {
          "destroy": "Are you sure you want to delete this component? This action can't be reverted."
        },
        "adminFleet": {
          "destroy": "Are you sure you want to delete this fleet? This action can't be reverted."
        },
        "adminNotifications": {
          "destroyAll": "確定要刪除所有通知嗎？此操作無法復原。",
          "destroySelected": {
            "one": "確定要刪除選取的通知嗎？此操作無法復原。",
            "other": "確定要刪除選取的 %{count} 則通知嗎？此操作無法復原。"
          }
        },
        "adminDestroyedFleet": {
          "restore": "確定要還原此艦隊嗎？",
          "restorePurged": "確定要還原這個已清除的艦隊嗎？還原只能盡力而為：角色、圖片、邀請連結與艦隊載具不會被還原。"
        },
        "adminUser": {
          "destroy": "Are you sure you want to delete this admin user? This action can't be reverted."
        },
        "image": {
          "destroy": "Are you sure you want to delete this image? This action can't be reverted."
        },
        "adminVehicle": {
          "destroy": "Are you sure you want to delete this vehicle? This action can't be reverted."
        },
        "commodity": {
          "destroy": "Are you sure you want to delete this commodity? This action can't be reverted."
        },
        "equipment": {
          "destroy": "Are you sure you want to delete this equipment? This action can't be reverted."
        },
        "notifications": {
          "destroyAll": "確定要刪除所有通知嗎？此操作無法復原。",
          "destroySelected": {
            "one": "確定要刪除選取的通知嗎？此操作無法復原。",
            "other": "確定要刪除選取的 %{count} 則通知嗎？此操作無法復原。"
          }
        },
        "unlistedModel": {
          "createModel": "根據 %{name} 建立飛船？下次 sc_data 載入會補齊其資料。"
        },
        "import": {
          "cleanup": "將此匯入標記為失敗？僅在工作確實已經消失時才這樣做——仍在執行的工作會在結束時報錯。",
          "cleanupSelected": "將所選匯入標記為失敗？只影響仍在執行的那些，確實仍在執行的工作會在結束時報錯。"
        },
        "hardpoint": {
          "destroy": "確定要刪除此掛載點嗎？此操作無法復原。"
        }
      },
      "oauthAuthorize": {
        "loading": "載入中...",
        "loadError": "載入授權詳情失敗。",
        "authorizeError": "授權失敗。",
        "denyError": "授權拒絕失敗。"
      },
      "oauth": {
        "disconnect": {
          "success": "服務商已成功中斷。",
          "failure": "無法中斷服務商。請重試。"
        }
      },
      "confirmAccess": {
        "failure": "無法確認存取。請檢查密碼並重試。"
      },
      "setEmail": {
        "success": "確認郵件已發送到您的新郵箱地址，請檢查收件匣。",
        "failure": "無法更新電子郵件地址，請重試。"
      },
      "confirmAccessEmail": {
        "sent": "確認碼已傳送到您的電子郵件。",
        "failure": "無法傳送確認郵件。請重試。"
      },
      "confirmAccessCode": {
        "failure": "確認碼無效或已過期。"
      },
      "import": {
        "started": "%{type} 匯入已開始...",
        "finished": "%{type} 匯入成功完成。",
        "failed": "%{type} 匯入失敗: %{info}"
      },
      "syncExtension": {
        "started": "正在同步您的機庫...",
        "success": "您的機庫已同步。",
        "failure": "您的機庫無法同步。",
        "notLoggedIn": "您需要在<a href=\"https://robertsspaceindustries.com\" target=\"_blank\">https://robertsspaceindustries.com</a>登入以同步您的機庫。"
      },
      "admin": {
        "supporterContributions": {
          "patreonSyncStarted": "Patreon 同步已開始。請在一分鐘後重新整理以查看匯入的支持者。"
        },
        "imports": {
          "cleaned": "匯入已標記為失敗",
          "cleanedUp": {
            "one": "已將 %{count} 個匯入標記為失敗",
            "other": "已將 %{count} 個匯入標記為失敗"
          },
          "noneRunning": "所選內容中沒有仍在執行的匯入",
          "cleanupError": "無法清理該匯入"
        }
      },
      "logistics": {
        "request": {
          "create": {
            "success": "Logistics request created.",
            "failure": "Could not create logistics request."
          }
        },
        "inventory": {
          "create": {
            "success": "Inventory created.",
            "failure": "Could not create inventory."
          },
          "update": {
            "success": "Inventory updated.",
            "failure": "Could not update inventory."
          },
          "destroy": {
            "success": "Inventory deleted.",
            "failure": "Could not delete inventory."
          }
        },
        "inventoryItem": {
          "create": {
            "success": "Item added to inventory.",
            "failure": "Could not add item to inventory."
          },
          "deposit": {
            "success": "Deposit recorded.",
            "failure": "Could not record deposit."
          },
          "withdrawal": {
            "success": "Withdrawal recorded.",
            "failure": "Could not record withdrawal. Check available stock."
          },
          "destroy": {
            "success": "Entry deleted.",
            "failure": "Could not delete entry.",
            "confirm": "Delete this entry? The stock it added or removed is corrected accordingly."
          }
        },
        "comment": {
          "create": {
            "success": "Comment added.",
            "failure": "Could not add comment."
          }
        },
        "csvImport": {
          "success": "%{count} items imported successfully.",
          "failure": "Could not import CSV file."
        },
        "stockItem": {
          "update": {
            "success": "Item updated.",
            "failure": "Could not update item."
          },
          "destroy": {
            "success": "Item deleted.",
            "failure": "Could not delete item.",
            "confirm": "Delete this item and all %{count} of its entries? This cannot be undone."
          }
        },
        "vehicleInventory": {
          "clear": {
            "confirm": "清空這艘飛船的貨物？所有記錄都會被刪除。",
            "success": "貨物已清空。",
            "failure": "無法清空貨物。"
          }
        }
      },
      "adminNotifications": {
        "unread": "通知已標示為未讀",
        "archived": "通知已封存",
        "unarchived": "通知已移回收件匣",
        "readAll": "所有通知已標示為已讀",
        "destroyed": "通知已刪除",
        "destroyedAll": "所有通知已刪除",
        "error": "發生錯誤",
        "bulk": {
          "read": {
            "one": "%{count} 則通知已標示為已讀",
            "other": "%{count} 則通知已標示為已讀"
          },
          "unread": {
            "one": "%{count} 則通知已標示為未讀",
            "other": "%{count} 則通知已標示為未讀"
          },
          "archived": {
            "one": "%{count} 則通知已封存",
            "other": "%{count} 則通知已封存"
          },
          "unarchived": {
            "one": "%{count} 則通知已移回收件匣",
            "other": "%{count} 則通知已移回收件匣"
          },
          "destroyed": {
            "one": "%{count} 則通知已刪除",
            "other": "%{count} 則通知已刪除"
          }
        }
      },
      "fleets": {
        "notifications": {
          "update": {
            "success": "通知設定已儲存。",
            "failure": "無法儲存通知設定。"
          }
        },
        "mission": {
          "create": {
            "success": "任務已建立。",
            "failure": "無法建立任務。"
          },
          "update": {
            "success": "任務已更新。",
            "failure": "無法更新任務。"
          },
          "archive": {
            "success": "任務已封存。",
            "failure": "無法封存任務。"
          },
          "unarchive": {
            "success": "任務已還原。",
            "failure": "無法還原任務。"
          },
          "destroy": {
            "success": "任務已刪除。",
            "failure": "無法刪除任務。",
            "confirm": "這會永久刪除該任務及其所有隊伍、飛船與席位。此操作無法復原。"
          }
        },
        "missionTeam": {
          "create": {
            "success": "隊伍已新增。",
            "failure": "無法新增隊伍。"
          },
          "update": {
            "success": "隊伍已更新。",
            "failure": "無法更新隊伍。"
          },
          "destroy": {
            "success": "隊伍已移除。",
            "failure": "無法移除隊伍。"
          }
        },
        "missionShip": {
          "create": {
            "success": "飛船已新增。",
            "failure": "無法新增飛船。"
          },
          "update": {
            "success": "飛船已更新。",
            "failure": "無法更新飛船。"
          },
          "destroy": {
            "success": "飛船已移除。",
            "failure": "無法移除飛船。"
          },
          "duplicate": {
            "success": "飛船已複製。",
            "failure": "無法複製此飛船。"
          }
        },
        "missionSlot": {
          "create": {
            "success": "席位已新增。",
            "failure": "無法新增席位。"
          },
          "update": {
            "success": "席位已更新。",
            "failure": "無法更新席位。"
          },
          "destroy": {
            "success": "席位已移除。",
            "failure": "無法移除席位。"
          }
        },
        "event": {
          "create": {
            "success": "活動已建立。",
            "failure": "無法建立活動。"
          },
          "update": {
            "success": "活動已更新。",
            "failure": "無法更新活動。"
          },
          "archive": {
            "success": "活動已封存。",
            "failure": "無法封存活動。",
            "confirm": "要封存此活動嗎？成員將不會再於即將舉行的清單中看到它。"
          },
          "unarchive": {
            "success": "活動已從封存還原。",
            "failure": "無法還原活動。"
          },
          "syncToDiscord": {
            "success": "活動已推送到 Discord。",
            "failure": "無法將活動推送到 Discord。"
          },
          "destroy": {
            "success": "活動已刪除。",
            "failure": "無法刪除活動。",
            "confirm": "這會永久刪除該活動。此操作無法復原。"
          },
          "publish": {
            "success": "活動已發布 — 報名現已開放。",
            "failure": "無法發布活動。"
          },
          "lockSignups": {
            "success": "報名已鎖定。",
            "failure": "無法鎖定報名。"
          },
          "unlockSignups": {
            "success": "報名已重新開放。",
            "failure": "無法重新開放報名。"
          },
          "start": {
            "success": "活動已開始。",
            "failure": "無法開始活動。"
          },
          "complete": {
            "success": "活動已標示為完成。",
            "failure": "無法完成活動。"
          },
          "cancel": {
            "success": "活動已取消。",
            "failure": "無法取消活動。",
            "confirm": "要取消此活動嗎？參加者將會收到通知。"
          }
        },
        "eventSignup": {
          "create": {
            "success": "您已報名。",
            "failure": "無法報名。"
          },
          "update": {
            "success": "報名已更新。",
            "failure": "無法更新報名。"
          },
          "withdraw": {
            "success": "您已退出此活動。",
            "failure": "無法取消報名。",
            "confirm": "要退出此活動嗎？"
          },
          "kick": {
            "success": "報名已移除。",
            "failure": "無法移除報名。",
            "confirm": "要移除這位成員的報名嗎？"
          }
        },
        "eventAdmin": {
          "create": {
            "success": "角色已授予。",
            "failure": "無法授予角色。"
          },
          "destroy": {
            "success": "角色已撤銷。",
            "failure": "無法撤銷角色。",
            "confirm": "要撤銷 %{username} 在此活動的角色嗎？"
          }
        },
        "eventTeam": {
          "create": {
            "success": "隊伍已新增。",
            "failure": "無法新增隊伍。"
          },
          "update": {
            "success": "隊伍已更新。",
            "failure": "無法更新隊伍。"
          },
          "destroy": {
            "success": "隊伍已移除。",
            "failure": "無法移除隊伍。",
            "confirm": "要移除此隊伍及其所有飛船與席位嗎？"
          }
        },
        "eventShip": {
          "create": {
            "success": "飛船已新增。",
            "failure": "無法新增飛船。"
          },
          "update": {
            "success": "飛船已更新。",
            "failure": "無法更新飛船。"
          },
          "destroy": {
            "success": "飛船已移除。",
            "failure": "無法移除飛船。",
            "confirm": "要移除此飛船及其席位嗎？"
          },
          "expand": {
            "success": "席位已新增。",
            "failure": "無法新增席位。"
          }
        },
        "eventSlot": {
          "create": {
            "success": "席位已新增。",
            "failure": "無法新增席位。"
          },
          "update": {
            "success": "席位已更新。",
            "failure": "無法更新席位。"
          },
          "destroy": {
            "success": "席位已移除。",
            "failure": "無法移除席位。"
          }
        }
      },
      "notifications": {
        "unread": "通知已標示為未讀",
        "archived": "通知已封存",
        "unarchived": "通知已移回收件匣",
        "readAll": "所有通知已標示為已讀",
        "destroyed": "通知已刪除",
        "destroyedAll": "所有通知已刪除",
        "actionDone": "完成",
        "actionFailed": "操作沒有成功 - 這則通知可能已經過期",
        "error": "發生錯誤",
        "bulk": {
          "read": {
            "one": "%{count} 則通知已標示為已讀",
            "other": "%{count} 則通知已標示為已讀"
          },
          "unread": {
            "one": "%{count} 則通知已標示為未讀",
            "other": "%{count} 則通知已標示為未讀"
          },
          "archived": {
            "one": "%{count} 則通知已封存",
            "other": "%{count} 則通知已封存"
          },
          "unarchived": {
            "one": "%{count} 則通知已移回收件匣",
            "other": "%{count} 則通知已移回收件匣"
          },
          "destroyed": {
            "one": "%{count} 則通知已刪除",
            "other": "%{count} 則通知已刪除"
          }
        }
      }
    }
  }
}
